<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-scrollbar class="custom-scroll" :style="{height: formConfig.height + 'px', 'min-height': '100px'}">
      <el-form ref="form" :model="formData" class="full-width-input" :rules="rules"
        :label-width="formConfig.labelWidth + 'px'" :size="defaultFormItemSize"
        :label-position="formConfig.labelPosition"
        @submit.native.prevent>
        <el-row :gutter="formConfig.gutter">
          <template v-for="widget in formConfig.formWidgetList">
            <CustomTable :ref="widget.variableName"
              v-if="widget.widgetType === SysCustomWidgetType.Table" :key="widget.id"
              :widgetConfig="widget"
              :formType="formConfig.formType"
              :primaryColumnName="widget.primaryColumnName"
              :isNew="isRelationTableAdd(widget)"
              :getTableQueryParams="getTableQueryParams"
              @operationClick="onTableOperationClick"
              :parentApiParams="apiparams"
              :operationObj="operationObj"
            />
            <CustomUpload :ref="widget.variableName" :key="widget.id"
              v-else-if="widget.widgetType === SysCustomWidgetType.Upload"
              :widgetConfig="widget"
              :flowData="flowData"
              :getDataId="getWidgetPrimaryColumnId"
              v-model="formData[getWidgetFieldName(widget)]" />
            <CustomWidget
              v-else
              :ref="widget.variableName"
              :key="widget.id"
              :widgetConfig="widget"
              :formConfig="formConfig"
              :getDropdownParams="getDropdownParams"
              v-model="formData[getWidgetFieldName(widget)]"
              @change="onChangeData"
              @EnterInput="onEnterInput"
              :operationObj="operationObj"
            >
              <template v-for="subWidget in widget.childWidgetList">
                <CustomTable :ref="subWidget.variableName"
                  v-if="subWidget.widgetType === SysCustomWidgetType.Table" :key="subWidget.id"
                  :widgetConfig="subWidget"
                  :formType="formConfig.formType"
                  :isNew="isRelationTableAdd(subWidget)"
                  :getTableQueryParams="getTableQueryParams"
                  @operationClick="onTableOperationClick"
                />
                <CustomUpload :ref="subWidget.variableName" :key="subWidget.id"
                  v-else-if="subWidget.widgetType === SysCustomWidgetType.Upload"
                  :widgetConfig="subWidget"
                  :flowData="flowData"
                  :getDataId="getWidgetPrimaryColumnId"
                  v-model="formData[getWidgetFieldName(subWidget)]" />
                <CustomWidget
                  v-else
                  :ref="subWidget.variableName"
                  :key="subWidget.id"
                  :widgetConfig="subWidget"
                  :formConfig="formConfig"
                  :getDropdownParams="getDropdownParams"
                  v-model="formData[getWidgetFieldName(subWidget)]"
                />
              </template>
            </CustomWidget>
          </template>
        </el-row>
      </el-form>
    </el-scrollbar>
    <el-row v-if="formConfig.formType === SysOnlineFormType.FORM && (operationObj ? !operationObj.infoType : true)" type="flex" justify="end" style="margin-top: 15px;">
      <el-button type="primary" :size="defaultFormItemSize" :plain="true"
        v-if="formConfig.formKind === SysOnlineFormKind.DIALOG"
        @click="onCancel(false)">
        取消
      </el-button>
      <el-button type="primary" :size="defaultFormItemSize"
        @click="onSave()">
        保存
      </el-button>
    </el-row>
    <el-row v-else-if="formConfig.formType === SysOnlineFormType.FORM && (operationObj ? operationObj.infoType === 2 : true)" type="flex" justify="end" style="margin-top: 15px;">
      <!-- <el-button type="primary" :size="defaultFormItemSize" :plain="true"
        v-if="formConfig.formKind === SysOnlineFormKind.DIALOG"
        @click="onCancel(false)">
        取消
      </el-button> -->
      <el-button type="primary" :size="defaultFormItemSize"
        @click="onPrint()">
        打印
      </el-button>
    </el-row>
    <el-row v-else-if="formConfig.formType === SysOnlineFormType.FORM && (operationObj ? operationObj.infoType === 3 : true)" type="flex" justify="end" style="margin-top: 15px;">
      <!-- <el-button type="primary" :size="defaultFormItemSize" :plain="true"
        v-if="formConfig.formKind === SysOnlineFormKind.DIALOG"
        @click="onCancel(false)">
        取消
      </el-button> -->
      <el-button type="primary" :size="defaultFormItemSize"
        @click="OnUnpackingOrSplicing()">
        拆包/拼包
      </el-button>
    </el-row>
    <el-row v-else-if="formConfig.formType === SysOnlineFormType.FORM && (operationObj ? operationObj.infoType === 4 : true)" type="flex" justify="end" style="margin-top: 15px;">
      <!-- <el-button type="primary" :size="defaultFormItemSize" :plain="true"
        v-if="formConfig.formKind === SysOnlineFormKind.DIALOG"
        @click="onCancel(false)">
        取消
      </el-button> -->
      <el-button type="primary" :size="defaultFormItemSize"
        @click="getPrintInfo2()">
          生成打印标签
      </el-button>
    </el-row>
    <el-row v-else-if="formConfig.formType === SysOnlineFormType.FORM && (operationObj ? operationObj.infoType === 5 : true)" type="flex" justify="end" style="margin-top: 15px;">
      <!-- <el-button type="primary" :size="defaultFormItemSize" :plain="true"
        v-if="formConfig.formKind === SysOnlineFormKind.DIALOG"
        @click="onCancel(false)">
        取消
      </el-button> -->
      <el-button type="primary" :size="defaultFormItemSize"
        @click="onPrint2()">
          打印
      </el-button>
    </el-row>
    <el-row v-else-if="formConfig.formType === SysOnlineFormType.FORM && (operationObj ? operationObj.infoType === 7 : true)" type="flex" justify="end" style="margin-top: 15px;">
      <el-button type="primary" :size="defaultFormItemSize" :plain="true"
        v-if="formConfig.formKind === SysOnlineFormKind.DIALOG"
        @click="onCancel(false)">
        取消
      </el-button>
      <el-button type="primary" :size="defaultFormItemSize"
        @click="onQuality()">
          确认并报工
      </el-button>
    </el-row>
    <el-row v-if="formConfig.formType === SysOnlineFormType.FORM && (operationObj ? operationObj.infoType === 8 : true)" type="flex" justify="end" style="margin-top: 15px;">
      <!-- <el-button type="primary" :size="defaultFormItemSize" :plain="true"
        v-if="formConfig.formKind === SysOnlineFormKind.DIALOG"
        @click="onCancel(true)">
        取消
      </el-button> -->
      <!-- <el-button type="primary" :size="defaultFormItemSize"
        @click="onSave(true)">
        保存
      </el-button> -->
    </el-row>
    <el-row v-if="formConfig.formType === SysOnlineFormType.FORM && (operationObj ? operationObj.infoType === 9 : true)" type="flex" justify="end" style="margin-top: 15px;">
      <el-button type="primary" :size="defaultFormItemSize" :plain="true"
        v-if="formConfig.formKind === SysOnlineFormKind.DIALOG"
        @click="onCancel(true)">
        取消
      </el-button>
      <el-button type="primary" :size="defaultFormItemSize"
        @click="onInAndOut(1)">
        保存
      </el-button>
    </el-row>
    <el-row v-if="formConfig.formType === SysOnlineFormType.FORM && (operationObj ? operationObj.infoType === 10 : true)" type="flex" justify="end" style="margin-top: 15px;">
      <el-button type="primary" :size="defaultFormItemSize" :plain="true"
        v-if="formConfig.formKind === SysOnlineFormKind.DIALOG"
        @click="onCancel(true)">
        取消
      </el-button>
      <el-button type="primary" :size="defaultFormItemSize"
        @click="onInAndOut(2)">
        保存
      </el-button>
    </el-row>

    <QrCode v-if="qrCodeShow" :labelType="1" :currentLabel="currentLabel" :labelNo="currentLabel.id" :modelInfo="modelInfo" />
  </div>
</template>

<script>

import { OnlineFormMixins } from './onlineFormMixins.js';
import CustomUpload from '@/views/onlineForm/components/customUpload.vue';
import CustomWidget from '@/views/onlineForm/components/customWidget.vue';
import CustomTable from '@/views/onlineForm/components/customTable.vue';

export default {
  name: 'onlineEditForm',
  inject: ['preview'],
  mixins: [OnlineFormMixins],
  props: {
    operationType: {
      type: [Number, String],
      required: true
    },
    saveOnClose: {
      type: String,
      default: '1'
    },
    rowData: {
      type: Object
    },
    flowData: {
      type: Object
    },
    fapiparams: {
      type: Object
    },
    operationObj: {
      type: Object
    },
    formInfo: {
      type: Object
    }
  },
  components: {
    CustomWidget,
    CustomTable,
    CustomUpload,
    QrCode: () => import("../../qrCode/index.vue"),
  },
  methods: {
    onInAndOut(i) {
      let _this = this;
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        console.log("_this.formData", _this.formData);

        let widget = _this.formConfig.formWidgetList.filter((el) => {
          return el.widgetType === _this.SysCustomWidgetType.Table;
        });
        if (!widget || widget.length === 0) return;
        let widgetItem = widget[0];
        let arr = _this.$refs[widgetItem.variableName][0].getTableData();
        let newArr = arr.map(el => {
          let newData = {}
          for (const key in el) {
            let newKey = key.split('__')[1];
            if(key.split('__') && key.split('__').length <= 2) {
              if(newKey === "batch_no") {
                newData['batchNo'] = el[key]
              } else
              if(newKey === "batch_type") {
                newData['batchType'] = el[key]
              } else
              if(newKey === "central_hole") {
                newData['centralHole'] = el[key]
              } else
              if(newKey === "install_method") {
                newData['installMethod'] = el[key]
              } else
              if(newKey === "product_code") {
                newData['productCode'] = el[key]
              } else
              if(newKey === "product_name") {
                newData['productName'] = el[key]
              } else
              if(newKey === "product_spec") {
                newData['productSpec'] = el[key]
              } else
              if(newKey === "sales_contract") {
                newData['salesContract'] = el[key]
              } else
              if(newKey === "technical_code") {
                newData['technicalCode'] = el[key]
              } else
              if(newKey === "wiring_method") {
                newData['wiringMethod'] = el[key]
              } else
              if(newKey === "auto_id") {
                newData['autoId'] = el[key]
              } else
              if(newKey === "srcLine_id") {
                newData['srcLineId'] = el[key]
              } else
              if(newKey === "amount") {
                newData['amount'] = 1
              } else
              if(newKey === "measure") {
                newData['measure'] = "PCS"
              } else
              {
                newData[newKey] = el[key]
              }
            }
          }
          return newData
        })
        console.log("newArr", newArr);

        let params = {};
       
        if (i === 1) {
          params = {
            batchType: _this.formData.batch_type,
            mark: _this.formData.mark,
            slaveDtos: newArr
          };
          console.log("params", params);
          _this.addInStorage(params);
        } else {
          params = {
            ccusCode: _this.formData.cust_id,
            details: newArr,
            mark: _this.formData.mark,
          };
          console.log("params", params);
          _this.addOutStorage(params);
        }
      });
    },
    // 中擎 入库
    async addInStorage(params){
      await this.$api.addInStorage(params);
      this.onCancel(true); // 刷新列表
      this.$message.success("入库成功");
    },
    // 中擎 出库
    async addOutStorage(params){
      await this.$api.addOutStorage(params);
      this.onCancel(true); // 刷新列表
      this.$message.success("出库成功");
    },
    onEnterInput(val){
      if( this.operationObj && this.operationObj.infoType === 8 ) {
        console.log("onEnterInput", val);
        console.log("this.formData", this.formData);
        // this.formData.order_no_item = null;
        // this.onSave(true)
        this.onReportWork()
      } else return;
    },
    // 新增品质质检
    onQuality() {
      let _this = this;
      this.$refs.form.validate(valid => { if (!valid) return;
        console.log("新增品质质检 _this.formData", _this.formData);
        // let widget = _this.formConfig.formWidgetList.filter((el) => {
        //   return el.widgetType === _this.SysCustomWidgetType.Table;
        // });
        // if (!widget || widget.length === 0) return;
        // let widgetItem = widget[0];
        // let arr = _this.$refs[widgetItem.variableName][0].getTableData();
        // let newArr = arr.map(el => {
        //   let newData = {}
        //   for (const key in el) {
        //     let newKey = key.split('__')[1];
        //     if(key.split('__') && key.split('__').length <= 2) {
        //       if(newKey === "item_code") {
        //         newData['itemCode'] = el[key]
        //       }
        //       if(newKey === "item_value") {
        //         newData['itemValue'] = el[key]
        //       }
        //       if(newKey === "status") {
        //         newData['status'] = el[key]
        //       }
        //     }
        //   }
        //   return newData
        // })
        // console.log("newArr", newArr);
        let params =  {
          orderNoItem: _this.formData.order_no_item,
          orderType: _this.formData.order_type,
          processesId: _this.formData.processes_id,
          productLine: _this.formData.product_line,
          // slaveData: newArr,
          status: _this.formData.status,
          reason: _this.formData.reason.join(','),
          productLineinfo: _this.formData.product_lineinfo,
        }
        _this.addQualityInspect(params)
      });
    },
    // 新增品质质检 接口
    async addQualityInspect(params) {
      await this.$api.addQualityInspect(params);
      this.onCancel(true); // 刷新列表
    },
    // 报工
    onReportWork(){
      let _this = this;
      this.$refs.form.validate(valid => { if (!valid) return;
        console.log("报工 _this.formData", _this.formData);
        let params =  {
          amount: _this.formData.amount,
          orderNoItem: _this.formData.order_no_item,
          processesId: _this.formData.processes_id,
          productLine: _this.formData.product_line,
          productLineinfo: _this.formData.product_lineinfo,
        }
        _this.selectByOrderNoItem(params)
      });
    },

    // 新增报工 接口
    async addProduceWorkReport(params) {
      await this.$api.addProduceWorkReport(params);
      // this.onCancel(true); // 刷新列表
      this.formData.order_no_item = null;
      this.$message.success("自动报工成功");
    },
    // 新增报工查询 接口
    async selectByOrderNoItem(params) {
      let _this = this;
     let { data } = await this.$api.selectByOrderNoItem(params);
     console.log("data", data);
     // this.onCancel(true); // 刷新列表
     if (data) {
        _this.$confirm('检测到重复数据，是否重新生产？').then(res => {
          _this.addProduceWorkReport(params)
        }).catch(e => {});
      } else {
        _this.addProduceWorkReport(params)
      }
    },

    // 拆包、拼包
    OnUnpackingOrSplicing() {
      let datasourceId = (this.masterTable.datasource || {}).datasourceId;
      let relationId = (this.masterTable.relation || {}).relationId;
      if (datasourceId != null && datasourceId !== '') {
        // 从表数据
        let slaveData = {};
        if (relationId == null) {
          console.log("1 -- 1");

          if (Array.isArray(this.tableWidgetList) && this.tableWidgetList.length > 0 && Number.parseInt(this.operationType) === this.SysCustomWidgetOperationType.ADD) {
            this.tableWidgetList.forEach(tableWidget => {
              let tableData = this.getRelationTableData(tableWidget);
              if (tableData != null) {
                slaveData = tableData;
              }
            });
          }
        }
        let arr = []; 
        slaveData.forEach(el => {
          arr.push(el.label_no_old)
        })
        let params = {
          formId: this.formInfo.formId,
          labelList: arr,
          masterData: {
            pack_type: this.formData.pack_type,
            label_template_id: this.formData.label_template_id
          }
        }
        console.log("params", params);
        let httpCall = this.doUrl('/admin/online/onlineLabel/repack', 'post', params);
        httpCall.then(res => {
          // this.onCancel()
          this.onCancel(true, this.formData);
        }).catch(e => {});
      }
    },
    // 手动 获取打印标签列表
    getPrintInfo2(){
      console.log("this.fapiparams",this.fapiparams);
      console.log("onPrint ----- 1111111");
      console.log("this.formData", this.formData);
      let widget = this.formConfig.formWidgetList.filter((el) => {
        return el.widgetType === this.SysCustomWidgetType.Table;
      });
      if (!widget || widget.length === 0) return;
      let widgetItem = widget[0];
      let params = { formId: this.formInfo.formId, masterData: {...this.formData} }
      let httpCall = this.doUrl('/admin/online/onlineLabel/pack', 'post', params);
      httpCall.then(res => {
        let data = res.data[this.formInfo.formCode]
        console.log('data', data)
        this.formData = {
          ...this.formData,
          ...data
        }
        if (data && data.label_template_id) this.getPrintModelInfo(data.label_template_id);
        this.printArr = res.data[widgetItem.variableName];
        this.$refs[widgetItem.variableName][0].setB(res.data[widgetItem.variableName]);
      }).catch(e => {});
    },

    // 获取打印标签列表
    getPrintInfo(){
      console.log("this.fapiparams",this.fapiparams);
      console.log("onPrint ----- 1111111");
      // return;
      let _this = this;
      let par = {}
      for (let i = 0; i < this.masterTable.columnList.length; i++) {
        let column = this.masterTable.columnList[i];
        if (column.primaryKey) {
          par.dataId = this.params[column.columnName];
          break;
        }
      }
      let { dataId } = par;
      let widget = this.formConfig.formWidgetList.filter((el) => {
        return el.widgetType === this.SysCustomWidgetType.Table;
      });
      if (!widget || widget.length === 0) return;
      let widgetItem = widget[0];
      let params = { formId: this.formInfo.formId, dataId }
      let httpCall = this.doUrl('/admin/online/onlineLabel/pack', 'post', params);
      httpCall.then(res => {
        let data = res.data[this.formInfo.formCode]
        console.log('data', data)
        this.formData = {
          ...this.formData,
          ...data
        }
        if (data && data.label_template_id) this.getPrintModelInfo(data.label_template_id);
        this.printArr = res.data[widgetItem.variableName];
        this.$refs[widgetItem.variableName][0].setB(res.data[widgetItem.variableName]);
      }).catch(e => {});
    },
    // 获取打印标签模板信息
    async getPrintModelInfo(id) {
      let { data } = await this.$api.getPrintModelInfo({
        id
      });
      this.modelInfo = data;
      console.log("this.modelInfo", this.modelInfo);
    },
    // 自动获取标签列表 打印标签接口
    onPrint(){
      console.log("onPrint ----- 1111111");
      console.log("printArr", this.printArr);
      let newArr = this.printArr.map(el => {
        let newData = {}
        for (const key in el) {
          let newKey = key.split('__')[1]
          newData[newKey] = el[key]
        }
        return newData
      })
      console.log("newArr", newArr);
      this.labelArr = newArr;
      this.num = 0;
      this.print(newArr[0], 0);
    },
    onIn(i) {
      console.log("onIn 222222");
      this.qrCodeShow = false;
      if (i == 2) {
        console.log("打印失败");
      } else {
        this.currentLabel = {
          labelInfo: null,
          labelType: null,
        };
        if (this.printNum < this.labelArr.length - 1) {
          this.printNum++;
          this.print(this.labelArr[this.printNum], this.printNum);
        } else if (this.printNum == this.labelArr.length - 1) {
          this.labelArr = [];
          // this.findPrintAgain();
          this.$message("打印完成,共打印" + (this.printNum + 1) + "张二维码");
        }
      }
    },
    //打印接口
    print(data, num) {
      console.log("data", data);
      this.currentLabel = { ...data }
      // this.data = {
      //   labelInfo: JSON.parse(data.labelInfo),
      //   labelType: data.labelType,
      // };
      console.log("this.currentLabel", this.currentLabel);
      setTimeout(() => {
        this.qrCodeShow = true;
      }, 100);
    },
    onPrint2(){
      this.getPrintModelInfo(this.formData.label_template_id);
      let widget = this.formConfig.formWidgetList.filter((el) => {
        return el.widgetType === this.SysCustomWidgetType.Table;
      });
      if (!widget || widget.length === 0) return;
      let widgetItem = widget[0];
      console.log("widgetItem", widgetItem);
      console.log("this.tableWidgetList", this.tableWidgetList);
      console.log("this.masterTable", this.masterTable);
      console.log("this.$refs[widgetItem.variableName][0].getTableData", this.$refs[widgetItem.variableName][0].getTableData());
      let arr = this.$refs[widgetItem.variableName][0].getTableData();
      let newArr = arr.map(el => {
        let newData = {}
        for (const key in el) {
          let newKey = key.split('__')[1]
          newData[newKey] = el[key]
        }
        return newData
      })
      console.log("newArr", newArr);
      this.labelArr = newArr;
      this.num = 0;
      this.print(newArr[0], 0);
    },

    // 下拉联动回显
    onChangeData(value, widgetConfig) {
      console.log("this.formData", this.formData);
      console.log("this.formInfo", this.formInfo);
      console.log("widgetConfig.columnName", widgetConfig.columnName);
      // return;
      let _this = this;
      if (!value) return;
      console.log("change 下拉框事件", value, widgetConfig);
      // if (widgetConfig.linkageVariableName)
      // this.$refs[widgetConfig.linkageVariableName][0].setB(value, widgetConfig)

      if (widgetConfig.linkFilter) {
        console.log("11111");
        let widget = this.formConfig.formWidgetList.filter((el) => {
          return el.widgetType === this.SysCustomWidgetType.Table;
        });
        if (!widget || widget.length === 0) return;
        let widgetItem = widget[0];
        console.log('widgetItem.variableName', widgetItem.variableName)
        // this.$refs[widgetItem.variableName][0].setB(value, widgetConfig);
        
        return new Promise((resolve, reject) => {
          let params = {
            formId: widgetConfig.linkageFormId,
            columnValue: value,
            columnKey: widgetConfig.columnName,
          };
          let httpCall = this.doUrl(
            "/admin/online/onlineForm/queryRefSlaveData",
            "get",
            params
          );
          httpCall
            .then((res) => {
              let data = res.data[this.formInfo.formCode]
              this.$refs[widgetItem.variableName][0].setB(res.data[widgetItem.variableName]);
              if (data && widgetConfig.linkageVariableName) {
                for (const key in data) {
                  console.log("data", data[key]);
                  if (key.includes("_OptionData")) {
                    let newKey = key.substring(0, key.length - 11);
                    console.log("newKey", newKey);
                    let getWidgetList = _this.formConfig.formWidgetList.filter((el) => el.columnName === newKey);
                    console.log("getWidgetList", getWidgetList);
                    if (!getWidgetList || getWidgetList.length === 0) return;
                    let getWidgetItem = getWidgetList[0];
                    _this.$refs[getWidgetItem.variableName][0].setOption(data[key]);
                  }
                }

                let infoData = data;
                Object.keys(this.formData).forEach((key) => {
                  let newKey = key;
                  if (key.includes('__')) newKey = key.split('__')[1];
                  if (newKey !== 'id')
                  _this.formData[key] = infoData[newKey] ? infoData[newKey] : _this.formData[key];
                });
              }
            })
            .catch((e) => {
              reject(e);
            });
        });

       
      } else if (widgetConfig.linkageVariableName) {
        console.log("2222");
        console.log("this.formData", this.formData);
        console.log("this.formInfo",this.formInfo);
        return new Promise((resolve, reject) => {
          console.log("11111 Promise");
          let params = {
            formId: widgetConfig.linkageFormId,
            columnValue: value,
            columnKey: widgetConfig.columnName,
          };
          console.log("22222 Promise");
          let httpCall = this.doUrl(
            "/admin/online/onlineForm/queryRefSlaveData",
            "get",
            params
          );
          httpCall
            .then((res) => {
              console.log("this.formInfo.formCode",this.formInfo.formCode);
              let data = res.data[this.formInfo.formCode]
              console.log("data", data);
              if (data) {
                for (const key in data) {
                  console.log("data", data[key]);
                  if (key.includes("_OptionData")) {
                    let newKey = key.substring(0, key.length - 11);
                    console.log("newKey", newKey);
                    console.log("_this.formConfig.formWidgetList", _this.formConfig.formWidgetList);
                    let getWidgetList = _this.formConfig.formWidgetList.filter((el) => el.columnName === newKey);
                    console.log("getWidgetList", getWidgetList);
                    if (!getWidgetList || getWidgetList.length === 0) return;
                    let getWidgetItem = getWidgetList[0];
                    _this.$refs[getWidgetItem.variableName][0].setOption(data[key]);
                  }
                }

                let infoData = data;
                Object.keys(this.formData).forEach((key) => {
                  console.log('key', key);
                  let newKey = key;
                  if (key.includes('__')) newKey = key.split('__')[1];
                  if (newKey !== 'id')
                  _this.formData[key] = infoData[newKey] ? infoData[newKey] : _this.formData[key];
                });
              }
            })
            .catch((e) => {
              reject(e);
            });
        });
      }
      // console.log("this.$refs[widgetConfig.linkageVariableName]", this.$refs[widgetConfig.linkageVariableName]);
      // console.log(this.formConfig.formWidgetList);
      // let widget = this.formConfig.formWidgetList.filter(el => {
      //   return el.widgetType === this.SysCustomWidgetType.Table
      // })
      // console.log('SysCustomWidgetType',this.SysCustomWidgetType.Table);
      // console.log("widget",widget);
      // if(!widget || widget.length === 0) return;
      // let widgetItem = widget[0]
      // console.log("widgetItem.variableName", widgetItem.variableName);
      // console.log("this.$refs[widgetItem.variableName]", this.$refs[widgetItem.variableName]);
      // this.$refs[widgetItem.variableName][0].setB()
    },
    getWidgetFieldName (widget) {
      if (widget && widget.relation == null) {
        return (widget.column || {}).columnName;
      } else {
        return widget.relation.variableName + '__' + (widget.column || {}).columnName
      }
    },
    // 当前表格是否为新建从表数据
    isRelationTableAdd (tableWidget) {
      let temp = Number.parseInt(this.operationType) === this.SysCustomWidgetOperationType.ADD && tableWidget.relation != null;
      return temp;
    },
    onCancel (isSuccess, data) {
      this.$emit('close', isSuccess, data);
    },
    onSave (isClose) {
      if (this.preview()) return;
      console.log("this.fapiparams",this.fapiparams);
      setTimeout(() => {
        this.$refs.form.validate(valid => {
          if (!valid) return;
          let datasourceId = (this.masterTable.datasource || {}).datasourceId;
          let relationId = (this.masterTable.relation || {}).relationId;
          let params = {
            datasourceId,
            relationId,
            masterData: relationId == null ? this.formData : undefined
          }
          // 添加调用按钮接口代码
          if (this.saveOnClose === '1') {
            console.log("1111");
            if (datasourceId != null && datasourceId !== '') {
              // 从表数据
              let slaveData = {};
              if (relationId == null) {
                console.log("1 -- 1");

                if (Array.isArray(this.tableWidgetList) && this.tableWidgetList.length > 0 && Number.parseInt(this.operationType) === this.SysCustomWidgetOperationType.ADD) {
                  this.tableWidgetList.forEach(tableWidget => {
                    let tableData = this.getRelationTableData(tableWidget);
                    if (tableData != null) {
                      slaveData[tableWidget.relation.relationId] = tableData;
                    }
                  });
                }
              } else {
                console.log("1 -- 2");

                slaveData = this.masterTable.columnList.reduce((retObj, column) => {
                  let fieldName = this.masterTable.relation.variableName + '__' + column.columnName;
                  retObj[column.columnName] = this.formData[fieldName];
                  return retObj;
                }, {});
                console.log("this.params", this.params, "slaveData", slaveData);
                slaveData = {
                  ...slaveData,
                  ...this.params,
                }
              }
              params.slaveData = slaveData;
              // params.slaveData.video_course_id = '1037103328223401584';
              let httpCall = null;

              console.log("params", params);
              if (Number.parseInt(this.operationType) === this.SysCustomWidgetOperationType.ADD) {
                if (relationId == null) {
                  httpCall = this.doUrl('/admin/online/onlineOperation/addDatasource/' + (this.masterTable.datasource || {}).variableName, 'post', params);
                } else {
                  params.slaveData.id = null;
                  httpCall = this.doUrl('/admin/online/onlineOperation/addOneToManyRelation/' + (this.masterTable.datasource || {}).variableName, 'post', {...params, masterDataId: this.fapiparams.dataId});
                }
              } else {
                if (relationId == null) {
                  httpCall = this.doUrl('/admin/online/onlineOperation/updateDatasource/' + (this.masterTable.datasource || {}).variableName, 'post', params);
                } else {
                  httpCall = this.doUrl('/admin/online/onlineOperation/updateOneToManyRelation/' + (this.masterTable.datasource || {}).variableName, 'post', params);
                }
              }
              httpCall.then(res => {
                if (!isClose) 
                this.onCancel(true, this.formData);
                else {this.formData.order_no_item = null; this.$message.success("自动报工成功");}
              }).catch(e => {});
            }
          } else {
            // 前端保存
            let masterData = {
              // 级联添加数据唯一标识
              __cascade_add_id__: this.formData.__cascade_add_id__ || new Date().getTime()
            };
            if (this.masterTable && Array.isArray(this.masterTable.columnList)) {
              this.masterTable.columnList.forEach(column => {
                let keyName = column.columnName;
                if (this.masterTable.relation) keyName = this.masterTable.relation.variableName + '__' + keyName;
                masterData[keyName] = this.formData[keyName];
              });

              if (Array.isArray(this.dropdownWidgetList)) {
                this.dropdownWidgetList.forEach(dropdwonWidget => {
                  let keyName = dropdwonWidget.column.columnName;
                  if (dropdwonWidget.table.relation) keyName = dropdwonWidget.table.relation.variableName + '__' + keyName;
                  let tempWidget = this.$refs[dropdwonWidget.variableName];
                  if (Array.isArray(tempWidget)) {
                    tempWidget.forEach(item => {
                      masterData[keyName + '__DictMap'] = {
                        id: this.formData[keyName],
                        name: item.getDictValue(this.formData[keyName])
                      }
                    });
                  }
                });
              }
            }
            if (!isClose) 
            this.onCancel(true, masterData);
            else {this.formData.order_no_item = null; this.$message.success("自动报工成功");}
          }
        });
      }, 30);
    },
    getTableQueryParams (widget) {
      console.log("widget.queryParamList 88888888", widget.queryParamList);
      let queryParams = [];
      if (Array.isArray(widget.queryParamList)) {
        queryParams = widget.queryParamList.map(item => {
          let paramValue = this.getParamValue(item.paramValueType, item.paramValue);
          console.log("item.paramValueType 88888888", item.paramValueType);
          console.log("item.paramValue 88888888", item.paramValue);
          if (paramValue == null || paramValue === '' || (Array.isArray(paramValue) && paramValue.length === 0)) return;
          console.log("paramValue 88888888", paramValue);
        
          let temp = {
            tableName: item.table.tableName,
            columnName: item.column.columnName,
            filterType: item.column.filterType,
            columnValue: item.column.filterType !== this.SysOnlineColumnFilterType.RANFGE_FILTER ? paramValue : undefined
          }
          if (item.column.filterType === this.SysOnlineColumnFilterType.RANFGE_FILTER) {
            temp.columnValueStart = paramValue[0];
            temp.columnValueEnd = paramValue[1];
          }
          return temp;
        }).filter(item => item != null);
      }

      return queryParams;
    },
    getDropdownParams (widget) {
      if (Array.isArray(widget.dictParamList)) {
        let params = {};
        for (let i = 0; i < widget.dictParamList.length; i++) {
          let dictParam = widget.dictParamList[i];
          if (dictParam.dictValue == null || dictParam.dictValueType == null) continue;
          params = this.getParamValueObj(dictParam.dictParamName, dictParam.dictValueType, dictParam.dictValue, params);
          if (params == null) return null;
        }

        return params;
      } else {
        return {};
      }
    },
    onTableOperationClick (operation, row, widget) {
      this.handlerOperation(operation, row, widget,Object.fromEntries(
            Object.entries(this.formData)
              .filter(([key, value]) => value !== null && value !== undefined && Object.keys(value).length !== 0)
        ));
    }
  },
  mounted () {
    console.log("operationObj", this.operationObj);
  }
}
</script>

<style>
</style>
